import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'ramda';
import { withTranslation } from 'react-i18next';
import { SortButton } from 'virtues-bootstrap';

const headerColumns = [
  { title: 'patient.status', sortKey: 'statusSort' },
  { title: 'patient.module', sortKey: 'module' },
  { title: 'patient.chapter', sortKey: 'charter' },
  { title: 'patient.feedback', sortKey: 'feedbackSort' },
];

const PatientEngagementHeader = ({ t, sortOrder, sortBy, sortTable }) => (
  <thead>
    <tr>
      {map(({ title, sortKey }) => (
        <td key={sortKey}>
          <SortButton
            onClick={sortTable}
            active={sortBy === sortKey}
            sortName={sortKey}
            direction={sortOrder}
          >
            {t(title)}
          </SortButton>
        </td>
      ))(headerColumns)}
    </tr>
  </thead>
);

PatientEngagementHeader.propTypes = {
  t: PropTypes.func.isRequired,
  sortTable: PropTypes.func.isRequired,
  sortOrder: PropTypes.string.isRequired,
  sortBy: PropTypes.string.isRequired,
};

export default withTranslation()(PatientEngagementHeader);
